import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getFiles({ commit, state }) {
    commit('setLoading', true);

    const {
      fileType = 'order',
      currentPage = 1,
      perPage = 10,
    } = state;

    const params = {
      file_type: fileType,
      current_page: currentPage,
      per_page: perPage,
    };

    return GraphQlClient.query(`
      query (
        $file_type: String,
        $current_page: Int,
        $per_page: Int
      ) {
        files (
          file_type: $file_type,
          current_page: $current_page,
          per_page: $per_page,
        ) {
          items {
            file_name,
            process_date,
            process_status,
            download_url,
            upload_date,
          }
          total
        }
      }
    `, params)
      .then(({ data = {} }) => {
        const {
          items = [],
          total = 0,
        } = data.files || {};

        commit('setFiles', items);
        commit('setFilesCount', total);
        commit('setLoading', false);

        return Promise.resolve(data);
      })
      .catch((err) => {
        commit('setLoading', false);

        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/order-importer/store/actions.js